import { TEmailReport } from "@cakemail-org/ui-components-v2"

export const emptyReportLog: TEmailReport = {
    unique_click_rate: 0,
    interval_start: 0,
    interval_end: 0,
    submitted: 0,
    processed: 0,
    rejected: 0,
    queued: 0,
    error: 0,
    delivered: 0,
    delivery_rate: 0,
    unique_open: 0,
    unique_open_rate: 0,
    open: 0,
    open_rate: 0,
    unique_click: 0,
    click: 0,
    clickthru_rate: 0,
    click_rate: 0,
    soft_bounce: 0,
    hard_bounce: 0,
    bounce_rate: 0,
    bounce: 0,
    unsubscribe: 0,
    unsubscribe_rate: 0,
    global_unsubscribe: 0,
    global_unsubscribe_rate: 0,
    spam: 0,
    spam_rate: 0,
    reject_rate: 0,
    error_rate: 0,
}